import { createFileRoute } from '@tanstack/react-router'

import { isSuccess } from '@orus.eu/result'

import { PaymentMethodsPageSkeleton } from '#/modules/payment/front-office/payment-methods-page/payment-methods-page-skeleton.tsx'
import { PaymentMethodsPage } from '#/modules/payment/front-office/payment-methods-page/payment-methods-page.tsx'
import { requirePermissions } from '#/shared/routing/require-permissions.ts'

export const Route = createFileRoute('/(customer)/_shell/payment-methods-v2/')({
  beforeLoad: ({ context }) => requirePermissions(context, ['paymentMethod.read', 'paymentAccount.update']),
  loader: async ({ context }) => {
    const sessionResult = await context.session.getSessionResult()
    if (!isSuccess(sessionResult)) return

    const user = sessionResult.output.user
    if (!user) return

    return context.queryClient.ensureQueryData(
      context.trpc.paymentMethod.getMethodsWithAssignedContracts.queryOptions({ userId: user.id }),
    )
  },
  pendingComponent: PaymentMethodsPageSkeleton,
  pendingMs: 150,
  component: PaymentMethodsPage,
})
